import React, {useCallback} from 'react';
import {QRCodeCanvas} from 'qrcode.react';
import {useTranslation} from 'react-i18next';
import * as css from './TicketQr.css';

interface TicketQrProps {
    barcode: string;
    onZoom: () => void;
}

function TicketQr({barcode, onZoom}: TicketQrProps) {
    const {t} = useTranslation('eTicket');

    const handleClick = useCallback(() => {
        onZoom();
    }, [onZoom]);

    return (
        <css.qr
            type="button"
            onClick={handleClick}
            aria-label={t('qrAlt')}
            data-cy="ticket-qr">
            <QRCodeCanvas value={barcode} size={200} />
        </css.qr>
    );
}

export default TicketQr;
